import type { ReactNode } from "react";
import { DocumentViewer } from "@dearbill/shared";
import type { PdfBlob } from "./usePdfBlob";

interface DocumentPreviewProps {
  title: string;
  doc: PdfBlob;
  /** The download fallback's file name. */
  filename: string;
}

/**
 * The prefilled document above a sign form: pdf.js draws the blob, and a
 * plain download of the same bytes is the fallback for members who would
 * rather read it in their own PDF app.
 */
export function DocumentPreview({ title, doc, filename }: DocumentPreviewProps): ReactNode {
  return (
    <div className="mt-6">
      <span className="text-midnight mb-2 block text-sm font-medium">{title}</span>
      <DocumentViewer file={doc.blob} title={title} />
      <p className="text-body-sm text-slate-teal mt-2">
        Preview not loading?{" "}
        <a
          href={doc.url}
          download={filename}
          className="text-primary-text underline hover:no-underline"
        >
          Download the form
        </a>
      </p>
    </div>
  );
}
